/* 
  大口注文のご案内に関わるカスタマイズを記述

*/

const contactForm = document.getElementById('contact_form'),
	url = 'https://script.google.com/macros/s/AKfycbwe52nGcUEQyu5nSP1_61N4Y8IYSokAoJnuvnho6qO0CG6Udu13jU3G3BhazCwVXFJF/exec';

contactForm.addEventListener('submit', function(e) {
	e.preventDefault();

	var formData = new FormData(form);
	var object = {};
	formData.forEach(function(value, key){
			object[key] = value;
	});
	var json = JSON.stringify(object);

	function getSheetData(){
			fetch(url, {
					method: 'GET', // GETリクエスト
					headers: {
							'Content-Type': 'application/json',
							// 他に必要なヘッダーがあればここに追加
					},
					body: json, // JSONデータを送信
			})
			.then(response => response.json())
			.then(data => {
					console.log(data);
			})
			.catch(error => {
					console.log('Error:', error);
			});
	}

	alert("送信処理")
	// getSheetData();
});


var OrderContactValidation = function(configrations){
  var self = this;
  self.ordercontactForms = new Array();
  for(var i=0;i<configrations.length;i++){
    self.ordercontactForms[i] = new OrderContactForm(configrations[i]);
  }

  //console.log(self.ordercontactForms);
  self.validate = function(){
    self.beforeValidation();
    var noError = true;
    for(var i=0;i<self.ordercontactForms.length;i++){
      //console.log(self.ordercontactForms[i].config["name"]);
      if(!self.ordercontactForms[i].validate()){
        noError = false;
      }
    }
    return noError;
  }

  self.getElement = function(elmName){
    for(var i=0;i<self.ordercontactForms.length;i++){
      if(self.ordercontactForms[i].config["name"] == elmName){
        return self.ordercontactForms[i];
      }
    }
  }
  self.getValues = function()
  {
    var ret=new Object();
    for(var i=0;i<self.ordercontactForms.length;i++){
      console.log(self.ordercontactForms[i].config["name"],self.ordercontactForms[i].val());
      ret[self.ordercontactForms[i].config["name"]] = self.ordercontactForms[i].val();
    }
    return ret;
  }
  self.validateAndGetValues = function()
  {
    if(self.validate()){
      return self.getValues();
    }else{
      return false;
    }
  }

  self.changeRule = function(elmName,ruleArray){
    var elm = self.getElement(elmName);
    elm.config["rules"] = ruleArray;
  }

  self.beforeValidation = function(){

  }
}

var OrderContactForm = function(config){
	var self = this;
	self.config = config;
	self.errors = new Array();
	self.validate = function(){
		var val = self.val();
		self.errors = new Array();
		if(typeof(self.config["rules"])!="undefined" && self.config["rules"]!=null){

			if(self.config["rules"].length){
				for(var i=0;i<self.config["rules"].length;i++){
					var rule = self.config["rules"][i];
					if(rule == "required"){
						if(typeof(val)=="undefined" || val=="" || val==null){
							$(".validation-"+self.config["name"]).addClass("error-required");
							self.errors.push("required");
						}else{
							$(".validation-"+self.config["name"]).removeClass("error-required");
							self.errors  = self._removeFromArray ("required",self.errors);
						}
					}

					if(rule == "email"){
						var regexp = /^[A-Za-z0-9]{1}[A-Za-z0-9_.+-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/;
						if (!regexp.test(val)) {
							$(".validation-"+self.config["name"]).addClass("error-email");
							self.errors.push("email");
						}else{
							$(".validation-"+self.config["name"]).removeClass("error-email");
							self.errors  = self._removeFromArray ("email",self.errors);
						}
					}

					if(rule == "number" || rule == "numeric" ){
						//console.log("NUMBER"+val);
						var regexp =  /^[0-9]*$/;
						if (!regexp.test(val)) {
							$(".validation-"+self.config["name"]).addClass("error-number");
							self.errors.push("number");
						}else{
							$(".validation-"+self.config["name"]).removeClass("error-number");
							self.errors  = self._removeFromArray ("number",self.errors);
						}
					}
					if(rule == "ascii"){
						var regexp = /^[\x20-\x7e]*$/;
						if (!regexp.test(val)) {
							$(".validation-"+self.config["name"]).addClass("error-ascii");
							self.errors.push("ascii");
						}else{
							console.log("OK")
							$(".validation-"+self.config["name"]).removeClass("error-ascii");
							self.errors  = self._removeFromArray ("ascii",self.errors);
						}
					}
					if(typeof rule === 'object'){
						Object.keys(rule).forEach(function (key) {
							if(key=="maxLength"){
								if(val.length > rule[key]){
									$(".validation-"+self.config["name"]).addClass("error-maxLength");
									self.errors.push("maxLength");
								}else{
									$(".validation-"+self.config["name"]).removeClass("error-maxLength");
									self.errors  = self._removeFromArray ("maxLength",self.errors);
								}
							}
							if(key=="minLength"){
								//console.log("-------",val.length)
								if(val.length < rule[key]){
									$(".validation-"+self.config["name"]).addClass("error-minLength");
									self.errors.push("minLength");
								}else{
									$(".validation-"+self.config["name"]).removeClass("error-minLength");
									self.errors  = self._removeFromArray ("minLength",self.errors);
								}
							}

							if(key=="regexp"){
								console.log("@@@@@");
								console.log(rule[key]);
								var str = "^[繧｡-繝ｳ繝ｴ繝ｼ縲\s]*$"
								var regexp = new RegExp(rule[key]);
								if (!regexp.test(val)) {
									$(".validation-"+self.config["name"]).addClass("error-regexp");
									self.errors.push("regexp");
								}else{
									$(".validation-"+self.config["name"]).removeClass("error-regexp");
									self.errors  = self._removeFromArray ("regexp",self.errors);
								}
							}


						});
					}


				}
			}
			//console.log(self.config["name"],self.config["rules"]);
			if(jQuery.inArray("required", self.config["rules"])==-1){
				$(".validation-"+self.config["name"]).removeClass("error-required");
				self.errors  = self._removeFromArray ("required",self.errors);
			}
			if(jQuery.inArray("email", self.config["rules"])==-1){
				$(".validation-"+self.config["name"]).removeClass("error-email");
				self.errors  = self._removeFromArray ("email",self.errors);
			}
			if(jQuery.inArray("number", self.config["rules"])==-1){
				$(".validation-"+self.config["name"]).removeClass("error-number");
				self.errors  = self._removeFromArray ("number",self.errors);
			}
		}
		if(self.errors.length==0){
			return true;
		}
		return false;
	}
	self.addRule = function(r){
		var chk = false;
		for(var i=0;i<self.config["rules"].length;i++){
			if(self.config["rules"][i]==r){
				chk = true;
			}
		}
		if(!chk){
			self.config["rules"].push(r);
		}
	}
	self.removeRule = function(r){
		console.log(self.config["name"],"remove",r);
		self.config["rules"]  = self._removeFromArray (r,self.config["rules"]);
		console.log(self.config["name"],self.config["rules"]);
	}
	self._removeFromArray = function(val,arr){
		var newArray = new Array();
		for(var i=0;i<arr.length;i++){
			if(arr[i]!=val){
				newArray.push(arr[i]);
			}
		}
		return newArray;
	}
	self.val = function(){
		if(self.config["type"]=="radio"){
			var val = $("*[validationName='"+self.config["name"]+"']:checked").val();
		}else if(self.config["type"]=="checkbox"){
			var val = $("*[validationName='"+self.config["name"]+"']:checked").map(function() {
				return $(this).val();
			}).get();
		}else{
			var val = $("*[validationName='"+self.config["name"]+"']").val();
		}
		if(typeof(val)=="undefined"){
			val = null;
		}
		if(self.config["type"]=="select"){
			if(val=="0"){
				//val = null;
			}
		}
		return val;
	}
}


	document.getElementById('receipt-selector').style.display = "none";
	function viewChangeReceipt(){
		if(document.getElementById('receipt')){
				id = document.getElementById('receipt').value;
				document.querySelector(".validation-receiptSendto").classList.remove("error-required");
				document.querySelector(".validation-receiptSendname").classList.remove("error-required");

				if(id == '不要'){
						document.getElementById('receipt-selector').style.display = "none";
						document. getElementById('receipt-sendto').value = '';
						document. getElementById('receipt-sendname').value = '';          
					
				}else if(id == '要'){
						document.getElementById('receipt-selector').style.display = "";
				}
		}
	}
	document.getElementById('invoice-selector').style.display = "none";
	const viewChangeInvoice = ()=>{
		if(document.getElementById('invoice-selector')){
			const id = document.getElementById('invoice').value;

			if(id == '不要'){
				document.getElementById('invoice-selector').style.display = "none";
				document.querySelectorAll('#invoice-selector input,#invoice-selector textarea').forEach(
					form_elem => {form_elem.value = '';}
				)
			}else if(id == '要'){
				document.getElementById('invoice-selector').style.display = "";
			}
		}
	}

	window.onload = viewChangeReceipt;
	window.onload = viewChangeInvoice;
    

function checkForm(event,_formId){
	event.preventDefault();

	var ordercontactFormConfigrations =[
		{
			"name": "company",
			"rules": [

			]
		},
		{
			"name": "department",
			"rules": [

			]
		},
		{
			"name": "pic",
			"rules": [
				"required"
			]
		},
		{
			"name": "kana",
			"rules": [
				"required"
			]
		},
		{
			"name": "phone",
			"rules": [
				"required"
			]
		},
		{
			"name": "email",
			"rules": [
				"required",
				"email"
			]
		},
		{
			"name": "yoto",
			"rules": [
				"required"
			]
		},
		{
			"name": "product",
			"rules": [
				"required"
			]
		},
		{
			"name": "quantity",
			"rules": [
				"required",
				"number"
			]
		},
		{
			"name": "delivery",
			"rules": [
				"required",
				"number"
			]
		},
		{
			"name": "untilMonth",
			"rules": [
				"required"
			]
		},
		{
			"name": "untilDay",
			"rules": [
				"required"
			]
		},
		{
			"name": "agree",
			"rules": [
				"required"
			]
		}
	];
	const receipt_select = document.getElementById('receipt').value;
	if(receipt_select == '領収書不要'){
		//不要：through 
	}else if(receipt_select == '要'){
		//要：add validation configurations
		ordercontactFormConfigrations.push(
			{
				"name": "receiptSendto",
				"rules": [
					"required"
				]
			},
			{
				"name": "receiptSendname",
				"rules": [
					"required"
				]
			}
		)
	}

	var ordercontactValidation = new OrderContactValidation(ordercontactFormConfigrations); 
	if(ordercontactValidation.validate()){
		var chk =  document.getElementById("agreeCheck");
		if (!chk.checked) {
			alert("「利用規約」と「個人情報取扱い同意書」に同意してください。");
		}else{
			contactForm.submit();
		}
	}else{
		alert("入力内容にエラーがあります。");
		//window.location.hash ="contact-content";
		var scroller = document.getElementById("contact-contentWrapper");
		$(window).scrollTop($(window).scrollTop()-$("#contact-contentWrapper").height()+600);
	}

}
